import React, { useState } from "react";
import PropTypes from "prop-types";
import { IconButton, Typography } from "@material-ui/core";
import { Drawer } from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import injectSheet from "react-jss";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";

import { Flex, Tipografia } from "../../../../_common";
import TimeLineAtividades from "../components/TimeLine/TimeLineAtividades";
import CardsDetalhesLeadAtividades from "../components/CardsDetalhesLeadAtividades/CardsDetalhesLeadAtividades";
import AbasDrawer from "./AbasDrawer";
import AbaObservacoes from "./AbaObservacoes";

const style = () => ({
  rootDrawer: { right: "unset" },
  containerTitulo: {
    height: 32,
    marginBottom: 16,
  },
  botaoAcao: {
    width: 32,
    height: 32,
  },
  listaLeads: {
    paddingTop: 24,
  },
  linkDetalheLead: {
    marginLeft: 8,
    color: "#457ab7",
    fontWeight: 700,
  },
});

function DrawerAtividadeIndividual({ aberto, atividade, onClose, cssDrawer, isJustDetalheLead = false, classes }) {
  const [active, setActive] = useState("detalhe");
  const intl = useIntl();

  return (
    <Drawer
      className={classes.rootDrawer}
      anchor="right"
      open={aberto}
      disableEnforceFocus
      hideBackdrop={isJustDetalheLead}
      disableAutoFocus={isJustDetalheLead}
      disableBackdropClick={isJustDetalheLead}
      sx={{ pointerEvents: isJustDetalheLead ? "none" : "" }}
    >
      <div style={{ pointerEvents: "auto" }}>
        <Flex flexDirection="column" className={cssDrawer}>
          <Flex justifyContent="space-between" alignItems="center" className={classes.containerTitulo}>
            <Flex justifyContent="flex-start">
              <Typography variant="h5">{atividade?.lead?.nome}</Typography>
            </Flex>
            <Flex justifyContent="flex-end">
              <Flex justifyContent="space-between">
                <Flex justifyContent="flex-end">
                  <IconButton aria-label="Close" onClick={onClose} className={classes.botaoAcao}>
                    <CloseIcon />
                  </IconButton>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
          <Flex alignItems="center" style={{ marginBottom: 16 }}>
            <PersonSearchIcon color="primary" />
            <Link to={`/spotter/detalhes-lead/${atividade?.lead?.id}`} target="_blank">
              <Tipografia tipo="subtituloConteudo" cor="primary" className={classes.linkDetalheLead}>
                {intl.formatMessage({ defaultMessage: "Veja o detalhe completo" })}
              </Tipografia>
            </Link>
          </Flex>
          <AbasDrawer active={active} setActive={setActive} />
          <Flex flexDirection="column" className={classes.listaLeads}>
            {active === "timeline" && <TimeLineAtividades lead={atividade?.lead} />}
            {active === "detalhe" && <CardsDetalhesLeadAtividades lead={atividade?.lead} />}
            {active === "observacoes" && <AbaObservacoes atividades={atividade !== null ? [atividade] : []} />}
          </Flex>
        </Flex>
      </div>
    </Drawer>
  );
}

DrawerAtividadeIndividual.propTypes = {
  aberto: PropTypes.bool,
  atividade: PropTypes.object,
  onClose: PropTypes.func,
  cssDrawer: PropTypes.string,
  isJustDetalheLead: PropTypes.bool,
};

export default injectSheet(style)(DrawerAtividadeIndividual);
